<template>
    <div :class="{ fadeout: !loading }" class="w-100 h-100 position-absolute left-0 top-0 bg-grey-darken-4"
        style="z-index:10000">

        <v-empty-state title="Loading..." :text="text">

            <template #media>

                <v-img class="mb-5" :src="logoSrc" />
                <v-progress-linear class="mb-5 mx-auto w-25" :color="progressColor" indeterminate />

            </template>
        </v-empty-state>

    </div>
</template>

<script>
import constants from '@/config/constants';

export default {
    name: 'SplashScreenLoader',
    data() {
        return {
            logoSrc: constants.app.logo.dark,
            progressColor: 'white',
        }
    },
    props: {
        loading: Boolean,
        text: String,
    },
};
</script>

<style scoped>
.fadeout {
    animation: fadeout 0.8s forwards;
    pointer-events: none;
}

@keyframes fadeout {
    to {
        opacity: 0;
        visibility: hidden;
    }
}
</style>
